import { connect } from 'react-redux';

import { Helmet } from 'react-helmet';

import _AppSwitcher, { AppLocationManager as _AppLocationManager } from './AppSwitcher';
import {
    CustomerNavbar as _CustomerNavbar,
    SpringboardNavbar as _SpringboardNavbar,
    GroupNavbar as _GroupNavbar,
} from './Navbar';

import { logout } from 'apps/core/auth/store';
import { fetchUser } from 'apps/core/user/store';
import { BrandHeader } from 'apps/core/site_options/store';

const defaultState = {
    currentApp: '',
    appTrail: [],
    breadcrumbs: { employergroup: null, employer: null},
    locations: {}, // {fooApp: {path: /foo, title: 'Foo'}
    apps: {},
};

// reducers

export const updateSwitcher = (state = defaultState, action = {}) => {
    const { app = '', path = '', title = '' } = action;

    let appTrail = [];
    const appTrailIndex = state.appTrail.indexOf(app);
    if (appTrailIndex >= 0) {
        appTrail = state.appTrail.slice(0, appTrailIndex + 1);
    } else {
        appTrail = [...state.appTrail, app];
    }

    return {
        ...state,
        appTrail,
        currentApp: app,
        locations: {
            ...state.locations,
            [app]: { path, title },
        },
    };
};

export const reducer = (state = defaultState, action = {}) => {
    switch (action.type) {
        case 'UPDATE_SWITCHER':
            // because the logic here cannot be incapsulated inside the single
            // expression required by the switch statement:
            return updateSwitcher(state, action);
        case 'UPDATE_BREADCRUMBS':
            const bc = {
                employergroup: action.employergroup !== undefined ? action.employergroup : state.breadcrumbs.employergroup,
                employer: action.employer !== undefined ? action.employer : state.breadcrumbs.employer,
                app: action.app !== undefined ? action.app : state.breadcrumbs.app,
            }
            return {
                ...state,
                breadcrumbs: bc,
            };
        case 'CLEAR_APP_TRAIL':
            return {
                ...state,
                appTrail: [],
            };

        case 'LOAD_APPS':
            return {
                ...state,
                apps: action.apps,
            };

        default:
            return state;
    }
};

// connected components

export const AppSwitcher = connect(
    ({ user, switcher }, ownProps) => ({
        user,
        apps: switcher.apps,
        currentApp: switcher.currentApp,
        currentTitle: Helmet.peek().title,
    }),
    (dispatch, ownProps) => ({
        fetchUser: (opts) => dispatch(fetchUser(opts)),
        updateAppLocation: (app, path, title) =>
            dispatch({
                type: 'UPDATE_SWITCHER',
                app,
                path,
                title,
            }),
        clearAppTrail: () => dispatch({ type: 'CLEAR_APP_TRAIL' }),
    })
)(_AppSwitcher);

export const AppLocationManager = connect(
    ({ switcher }, ownProps) => ({
        apps: switcher.apps,
        currentTitle: Helmet.peek().title,
    }),
    (dispatch, ownProps) => ({
        updateAppLocation: (app, path, title) =>
            dispatch({
                type: 'UPDATE_SWITCHER',
                app,
                path,
                title,
            }),
    })
)(_AppLocationManager);

export const SpringboardNavbar = connect(
    ({ user, site_options, switcher }, ownProps) => ({
        user,
        apps: switcher.apps,
        currentApp: switcher.currentApp,
        appTrail: switcher.appTrail,
        appLocations: switcher.locations,
        brand: site_options.brand,
    }),
    (dispatch, ownProps) => ({
        logout: () => dispatch(logout()),
    })
)(_SpringboardNavbar);

export const CustomerNavbar = connect(
    ({ user, site_options, switcher }, ownProps) => ({
        user,
        apps: switcher.apps,
        currentApp: switcher.currentApp,
        appTrail: switcher.appTrail,
        appLocations: switcher.locations,
        brand: site_options.brand,
        breadcrumbs: switcher.breadcrumbs,
        BrandHeader,
    }),
    (dispatch, ownProps) => ({
        logout: () => dispatch(logout()),
    })
)(_CustomerNavbar);

export const GroupNavbar = connect(
    ({ user, site_options, switcher }, ownProps) => ({
        user,
        apps: switcher.apps,
        currentApp: switcher.currentApp,
        appTrail: switcher.appTrail,
        appLocations: switcher.locations,
        brand: site_options.brand,
        breadcrumbs: switcher.breadcrumbs,
        BrandHeader,
    }),
    (dispatch, ownProps) => ({
        logout: () => dispatch(logout()),
    })
)(_GroupNavbar);
